class Popup {
    constructor(options = {}) {
        this.options = Object.assign(
            { 
                time: 4000
            }, 
            options
        );   
    } 

    buildPopup(target, message, waiting, type) { 
        if(target.querySelector(`.content-popup-nov`) == null){
            waiting = waiting || this.options.time; 

            let contentPopup = this.createElementWithClass("div", "content-popup-nov");

            if(type == "account"){ 
                contentPopup.classList.add("account");
            }

            let popup = this.createElementWithClass("div", "popup-nov");

            let close = this.createElementWithClass("div", "close");

            let msg = this.createElementWithClass("p", "popup-message");
            msg.textContent = message;

            let contentLoader = this.createElementWithClass("div", "content-loader");
            let loader = this.createElementWithClass("div", "loader");
            contentLoader.appendChild(loader); 

            popup.appendChild(close);
            popup.appendChild(msg);
            popup.appendChild(contentLoader);

            contentPopup.appendChild(popup);
            target.appendChild(contentPopup);

            let time = 0;
            contentPopup.classList.add("show");
            if(type != "account"){ 
                target.classList.add("popup-reception"); 
            }

            // Progression
            const intervalId = setInterval(() => { 
                time += 100;
                let rest = time * 100 / waiting;
                loader.style.width = rest + "%";
            }, 100);

            // Disparition
            const timeoutId =  setTimeout(() => {
                clearInterval(intervalId); // 🔥 important !
                contentPopup.classList.remove("show");  
                setTimeout(() => {
                    if(type != "account"){ 
                        target.classList.remove("popup-reception");
                    }
                    this.setCookie("popup-account", "1", 1);
                    contentPopup.remove(); 
                }, 300); // petit délai pour la transition CSS
            }, waiting);

            close.addEventListener("click", () => {
                this.setCookie("popup-account", "1", 15);
                clearTimeout(timeoutId);
                setTimeout(() => {
                    clearInterval(intervalId); // 🔥 important !
                    contentPopup.classList.remove("show");  
                    setTimeout(() => { 
                        if(type != "account"){ 
                            target.classList.remove("popup-reception");
                        }
                        contentPopup.remove(); 
                    }, 300); // petit délai pour la transition CSS
                }, 100);
            });
        }
    } 

    createElementWithClass(element, className) {
        let el = document.createElement(element);
        el.classList.add(className);
        return el;
    }

    deleteCookie(name){ 
        document.cookie = name + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    } 

    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    setCookie(name,value,days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    } 
}

const novPopup = new Popup();
